var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGiftcardCircles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 490,
    height: 312,
    viewBox: "0 0 490 312",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M422.807 52.6865C389.034 47.053 354.859 72.6757 334.212 114.203C328.841 63.3466 303.001 23.9767 266.223 17.8419C230.86 11.9433 195.07 38.3928 173.215 81.6649C165.459 39.6063 142.245 8.1026 110.432 2.79598C63.833 -4.97689 16.4674 46.3231 4.61582 117.374C-7.23577 188.425 20.9146 252.321 67.5133 260.094C100.35 265.572 133.567 241.668 154.475 202.198C161.998 248.201 186.782 282.763 221.078 288.484C257.53 294.564 294.438 266.243 316.086 220.587C321.733 267.238 345.984 303.121 380.062 308.806C426.422 316.538 473.591 265.474 485.388 194.75C497.185 124.025 469.166 60.4194 422.807 52.6865Z",
    stroke: "url(#paint0_linear_1002_2436)",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1002_2436",
    x1: 27.8506,
    y1: -21.9196,
    x2: 503.248,
    y2: 71.1922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92F23B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0FDFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftcardCircles);
export default __webpack_public_path__ + "static/media/giftcard-circles.c620268289fe2dfc6608e739316069f4.svg";
export { ForwardRef as ReactComponent };